// @ts-nocheck
// import useOverlayBadge from "@insite/client-framework/Common/Hooks/useOverlayBadge"; // Starter Custom Code
import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import sendProductRecommendationTracking from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/SendProductRecommendationTracking";
import translate from "@insite/client-framework/Translate";
import { BadgeImagePlacementValues, BadgeModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
// import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton"; // Bunzl Custom Code
// import ProductAddToListLink, {
//     ProductAddToListLinkStyles,
// } from "@insite/content-library/Components/ProductAddToListLink"; // Foundation
// import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand"; // Starter Custom Code
// import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription"; // Starter Custom Code
// import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage"; // Starter Custom Code
// import ProductImageBadges from "@insite/content-library/Components/ProductImageBadges"; // Bunzl custom code
// import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers"; // Starter Custom Code
// import ProductPrice from "@insite/content-library/Components/ProductPrice"; // Starter Custom Code
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductTextBadges from "@insite/content-library/Components/ProductTextBadges";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
// import Badge from "@insite/mobius/Badge"; // Starter Custom Code
import { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code */
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import AddToCartOptionsAndButton, {
    AddToCartOptionsAndButtonStyles,
} from "@store/Library/Components/Toolkit/AddToCartOptionsAndButton";
import Badge from "@store/MobiusOverrides/Badge/Badge";
import { ProductAddToCartButtonStyles } from "@store/Overrides/Components/ProductAddToCartButton";
// import ProductAttributes, { ProductAttributesStyles } from "@store/Overrides/Components/ProductAttributes"; // Foundation
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductAvailabilityStyles } from "@store/Overrides/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@store/Overrides/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@store/Overrides/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { productCardProps } from "@store/Themes/common/props/productCard";
import useOverlayBadge from "@toolkit/Modules/client-framework/Common/Hooks/useOverlayBadge";
/* Starter Custom Code */

/* Foundation - Start */
import {
    useIsHideSignInToSeePriceButton,
    useIsSignedInAndhasToBeSignedIn,
} from "@store/Framework/Store/Context/ContextHooks";
import ProductAttributes, { ProductAttributesStyles } from "@store/Overrides/Components/ProductAttributes";

/* Foundation - End */

/* Store Custom Code - Start */
import { ProductTextBadgesStyles } from "@store/Overrides/Components/ProductTextBadges";
import useSecondImageOnHover from "@store/Framework/Common/Hooks/useSecondImageOnHover";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import CompareCheckbox from "@store/Library/Components/Common/CompareCheckbox";
import ProductImageWithHover from "@store/Library/Components/ProductList/ProductImageWithHover";
import ProductAddToCartButton, {
    ProductAddToCartButtonProps,
} from "@store/Overrides/Components/ProductAddToCartButton";
import ProductAddToListLink, { ProductAddToListLinkStyles } from "@store/Overrides/Components/ProductAddToListLink";
import ProductImageBadges, {
    BadgeSizes,
    ProductImageBadgesStyles,
} from "@store/Overrides/Components/ProductImageBadges";
import { badgeSizes } from "@store/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import {
    actionsCardStyles,
    productCardInformationStyles,
    ProductListActionsStyles,
} from "@store/Themes/common/props/product";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
/* Store Custom Code - End */

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    productInfo: getProductInfoFromList(state, ownProps.carouselId, ownProps.product.id),
    // Starter Custom Code
    showInventoryAvailability: getSettingsCollection(state).productSettings.showInventoryAvailability,
});

const mapDispatchToProps = {
    updateProductInfo,
    sendProductRecommendationTracking,
};

interface OwnProps {
    carouselId: string;
    product: ProductModel;
    recommendationId?: number;
    showImage: boolean;
    showBrand: boolean;
    showTitle: boolean;
    showPartNumbers: boolean;
    showPrice: boolean;
    showAddToCart: boolean;
    showAddToList: boolean;
    showImageBadges?: boolean;
    maximumNumberOfImageBadges?: number;
    showTextBadges?: boolean;
    maximumNumberOfTextBadges?: number;
    extendedStyles?: ProductCarouselProductStyles;
    // Starter Custom Code
    showAttributes: boolean;
    showAvailability?: boolean;
    // Store Custom Code
    enableImageHover?: boolean;
    transitionDuration?: number;
    transitionTimingFunction?: string;
}

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

// Store Custom Code - extending interface
export interface ProductCarouselProductStyles extends ProductListActionsStyles {
    productImageStyles?: ProductImageStyles;
    productBrandWrapper?: InjectableCss;
    productBrandStyles?: ProductBrandStyles;
    productDescriptionStyles?: ProductDescriptionStyles;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    productPriceWrapper?: InjectableCss;
    productUnitOfMeasureSelectStyles?: SelectPresentationProps;
    productQuantityBreakPricingStyles?: ProductQuantityBreakPricingStyles;
    addToCartContainer?: GridContainerProps;
    qtyGridItem?: GridItemProps;
    productQuantityOrderedStyles?: TextFieldProps;
    addToCartButtonGridItem?: GridItemProps;
    // Store Custom Code
    productAddToCartButtonStyles?: ProductAddToCartButtonProps;
    productAddToListLinkStyles?: ProductAddToListLinkStyles;
    badgeAreaWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    badgeImageWrapper?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    badgeImageProps?: JSX.IntrinsicElements["img"];
    // Starter Custom Code
    attributesWrapper?: InjectableCss;
    attributes?: ProductAttributesStyles;
    availability?: ProductAvailabilityStyles;
    productActionsWrapper?: InjectableCss;
    productPrice?: ProductPriceStyles;
    addToCartOptionsAndButton?: AddToCartOptionsAndButtonStyles;
    productAddToListWrapper?: InjectableCss;
    // Foundation
    imageWrapper?: InjectableCss;
    productInformationWrapper?: InjectableCss;
    informationItem?: InjectableCss;
    brandWrapper?: InjectableCss;
    actionWrapper?: InjectableCss;
    price?: ProductPriceStyles;
    actionWrapperLeftColumn?: InjectableCss;
    actionWrapperRightColumn?: InjectableCss;
    actionButtons?: ButtonPresentationProps;
    // Store Custom Code
    productTextBadgesStyle?: ProductTextBadgesStyles;
    nonOverlayImageBadgesStyle?: ProductImageBadgesStyles;
    badgeSizes?: BadgeSizes;
    buttonRow?: InjectableCss;
}

export const productCarouselProductStyles: ProductCarouselProductStyles = {
    /* Store Custom Code - mixing in actionCardStyles */
    ...actionsCardStyles,
    productTextBadgesStyle: {
        tagWrapper: {
            extendedStyles: {
                wrapper: {
                    css: css`
                        margin-bottom: ${pxToRem(10)};
                        margin-top: 0;
                    `,
                },
            },
        },
    },
    nonOverlayImageBadgesStyle: {
        flexWrapper: {
            extendedStyles: {
                wrapper: {
                    css: css`
                        margin-bottom: ${pxToRem(10)};
                    `,
                },
            },
        },
    },
    productImageStyles: productCardProps.image,
    /* Store Custom Code - Start */
    productBrandStyles: productCardInformationStyles.brandStyles,
    productDescriptionStyles: productCardInformationStyles.descriptionStyles,
    /* Store Custom Code - End */
    attributesWrapper: productCardProps.spacingWrapper,
    productPartNumbersStyles: productCardProps.partNumbers,
    attributes: productCardProps.attributes,
    availability: productCardProps.availability,
    productActionsWrapper: productCardProps.actionsWrapper,
    productPriceWrapper: productCardProps.spacingWrapper,
    productPrice: productCardProps.price,
    productQuantityBreakPricingStyles: productCardProps.quantityBreakPricing,
    addToCartOptionsAndButton: productCardProps.addToCartOptionsAndButton,
    productAddToListWrapper: productCardProps.addToListWrapper,
    productAddToListLinkStyles: {
        button: {
            css: css`
                width: 100%;
            `,
        },
    } as ProductAddToListLinkStyles,
    badgeAreaWrapper: {
        css: css`
            position: relative;
        `,
    },
    badgeTextWrapper: {
        css: css`
            position: absolute;
            width: 50%;
            white-space: nowrap;
            overflow: hidden;
        `,
    },
    badgeImageWrapper: {
        css: css`
            position: absolute;
            width: 25%;
            height: 25%;
        `,
    },
    badgeText: {
        weight: "bold",
        css: css`
            width: 100%;
            margin: auto;
            ${wrapInContainerStyles}
        `,
    },

    // Store Custom Code
    imageWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            min-height: ${pxToRem(180)};
            position: relative;
            margin-bottom: 1.125rem;
        `,
    },
    productInformationWrapper: productCardInformationStyles.productInformationWrapper,
    informationItem: productCardInformationStyles.informationItem,
    brandWrapper: productCardInformationStyles.brandWrapper,
    // Store Custom Code
    badgeSizes,
    actionWrapper: actionsCardStyles.wrapper,
    price: actionsCardStyles.price,
    actionWrapperLeftColumn: actionsCardStyles.leftColumn,
    actionWrapperRightColumn: actionsCardStyles.rightColumn,
    actionButtons: actionsCardStyles.addToCartButton,
};

const ProductCarouselProduct = ({
    carouselId,
    product,
    showImage,
    showBrand,
    showTitle,
    showPartNumbers,
    showPrice,
    showAddToCart,
    showAddToList,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
    updateProductInfo,
    extendedStyles,
    productInfo,
    recommendationId,
    sendProductRecommendationTracking,
    // Starter Custom Code
    showAttributes,
    showAvailability,
    showInventoryAvailability,
    // Store Custom Code
    enableImageHover,
    transitionDuration,
    transitionTimingFunction,
}: Props) => {
    /* Store Custom Code - Start */
    const styles = useMergeProps(productCarouselProductStyles, extendedStyles);
    const { isVariantParent } = product;
    const isAuthenticated = useIsSignedInAndhasToBeSignedIn();
    /* Store Custom Code - End */
    const isSignedInAndhasToBeSignedIn = useIsSignedInAndhasToBeSignedIn();
    const isHideSignInToSeePriceButton = useIsHideSignInToSeePriceButton();

    const updateQuantity = (qtyOrdered: number) => {
        updateProductInfo({ id: carouselId, productId: product.id, qtyOrdered });
    };

    const updateUnitOfMeasure = (unitOfMeasure: string) => {
        updateProductInfo({ id: carouselId, productId: product.id, unitOfMeasure });
    };

    if (!product || !productInfo) {
        return null;
    }
    // Store Custom Code - >
    // carousels can't really support bottom left badges so we need to either restyle the carousel or override the badge placement
    const fixBadgePlacement = (badges: BadgeModel[]): BadgeModel[] => {
        const fixedBadges = badges.map(badge => {
            if (badge.largeImagePlacement === BadgeImagePlacementValues.BottomLeft) {
                return { ...badge, largeImagePlacement: BadgeImagePlacementValues.BottomRight };
            }
            return badge;
        });
        return fixedBadges;
    };

    const { badges } = product;
    const fixedProduct = badges ? { ...product, badges: fixBadgePlacement(badges) } : product;

    const productContext = {
        product: fixedProduct,
        productInfo,
        onUnitOfMeasureChanged: updateUnitOfMeasure,
        onQtyOrderedChanged: updateQuantity,
    };
    // Store Custom Code - <---

    const trackProductRecommendation = (isNewPageWasOpen: boolean) => {
        if (recommendationId) {
            sendProductRecommendationTracking({ recommendationId, isNewPageWasOpen });
        }
    };

    const { showOverlayBadge, overlayBadge, overlayBadgeWrapperStyles } = useOverlayBadge({
        productContext,
        showTextBadge: showTextBadges,
        showImageBadge: showImageBadges,
        styles,
    });
    const { imageBadges, textBadges } = useWidgetBadges({
        productContext,
        showTextBadges,
        showImageBadges,
    });

    const canAddToList = showAddToList && product.canAddToWishlist; // Starter Custom Code

    /* Foundation - Start */
    const buttonStyle: ButtonPresentationProps = isSignedInAndhasToBeSignedIn
        ? (styles.actionButtons as ButtonPresentationProps)
        : {
              ...styles.actionButtons,
              typographyProps: {
                  css: css`
                      white-space: normal;
                  `,
              },
          };
    /* Foundation - End */

    /* Bunzl - Start */
    const { hasSecondImage, handlers, hoverImageProductContext, isHovered } = useSecondImageOnHover(productContext);
    const isImageHoverEnabled = !!(hasSecondImage && enableImageHover);
    /* Bunzl - End */

    return (
        <>
            <ProductContext.Provider value={productContext}>
                {/* Bunzl - Start */}
                {showImage && !showOverlayBadge && (
                    <StyledWrapper
                        {...handlers}
                        {...styles.imageWrapper}
                        data-test-selector={`productCarouselProduct_imageWrapper_${product.id}`} /* Store Custom Code */
                    >
                        <ProductImageWithHover
                            hoverImageProduct={hoverImageProductContext}
                            isHovered={isHovered}
                            innerOnClick={() => trackProductRecommendation(false)}
                            transitionDuration={transitionDuration}
                            transitionTimingFunction={transitionTimingFunction}
                            extendedStyles={styles.productImageStyles}
                            size="medium"
                            enableImageHover={isImageHoverEnabled}
                            data-test-selector={`productCarouselProduct_image_${product.id}`} /* Store Custom Code */
                        />
                    </StyledWrapper>
                )}
                {/* Bunzl - End */}

                {showImage && showOverlayBadge && overlayBadge && (
                    <StyledWrapper
                        {...styles.badgeAreaWrapper}
                        data-test-selector={`productCarouselProduct_badgeAreaWrapper_${product.id}`} /* Store Custom Code */
                    >
                        {/* Bunzl - Start */}
                        <ProductImageWithHover
                            hoverImageProduct={hoverImageProductContext}
                            isHovered={isHovered}
                            transitionDuration={transitionDuration}
                            innerOnClick={() => trackProductRecommendation(false)}
                            transitionTimingFunction={transitionTimingFunction}
                            extendedStyles={styles.productImageStyles}
                            size="medium"
                            enableImageHover={isImageHoverEnabled}
                            data-test-selector={`productCarouselProduct_imageWithBadge_${product.id}`} /* Store Custom Code */
                        />
                        {/* Bunzl - End */}
                        <StyledWrapper
                            {...overlayBadgeWrapperStyles}
                            data-test-selector={`productCarouselProduct_overlayBadgeWrapper_${product.id}`} /* Store Custom Code */
                        >
                            <Badge
                                type={overlayBadge.badgeType}
                                value={
                                    overlayBadge.badgeType === "Image"
                                        ? overlayBadge.largeImageBadgePath
                                        : overlayBadge.displayText
                                }
                                badgeTextColor={overlayBadge.textColorHexCode}
                                badgeBackgroundColor={overlayBadge.badgeColorHexCode}
                                badgeTextRounding={overlayBadge.badgeStyle === "Round"} // Starter Custom Code
                                imageAltText={overlayBadge.imageAltText ? overlayBadge.imageAltText : overlayBadge.name}
                                textBadgeCss={styles.badgeText}
                                imageBadgeProps={styles.badgeImageProps}
                                data-test-selector={`productCarouselProduct_overlayBadge_${product.id}`} /* Store Custom Code */
                            />
                        </StyledWrapper>
                    </StyledWrapper>
                )}
                {/* Foundation - Start */}
                <StyledWrapper
                    {...styles.productInformationWrapper}
                    data-test-selector={`productCarouselProduct_infoWrapper_${product.id}`} /* Store Custom Code */
                >
                    <StyledWrapper
                        {...styles.brandWrapper}
                        data-test-selector={`productCarouselProduct_brandWrapper_${product.id}`} /* Store Custom Code */
                    >
                        {product.brand && showBrand && (
                            <ProductBrand
                                brand={product.brand}
                                extendedStyles={styles.productBrandStyles}
                                data-test-selector={`productCarouselProduct_brand_${product.id}`} /* Store Custom Code */
                            />
                        )}
                    </StyledWrapper>

                    {showTitle && (
                        <StyledWrapper
                            {...styles.informationItem}
                            data-test-selector={`productCarouselProduct_titleWrapper_${product.id}`} /* Store Custom Code */
                        >
                            <ProductDescription
                                product={productContext}
                                onClick={() => trackProductRecommendation(false)}
                                extendedStyles={styles.productDescriptionStyles}
                                data-test-selector={`productCarouselProduct_title_${product.id}`} /* Store Custom Code */
                            />
                        </StyledWrapper>
                    )}
                    {/* Starter Custom Code */}
                    {showPartNumbers || showAttributes ? (
                        <StyledWrapper
                            {...styles.attributesWrapper}
                            data-test-selector={`productCarouselProduct_partNumbersAttributesWrapper_${product.id}`} /* Store Custom Code */
                        >
                            {showPartNumbers && (
                                <ProductPartNumbers
                                    productNumber={product.productNumber}
                                    customerProductNumber={product.customerProductNumber}
                                    manufacturerItem={product.manufacturerItem}
                                    showCustomerName={false}
                                    showManufacturerItem={false}
                                    extendedStyles={styles.productPartNumbersStyles}
                                    data-test-selector={`productCarouselProduct_partNumbers_${product.id}`} /* Store Custom Code */
                                />
                            )}
                            {showAttributes ? (
                                <ProductAttributes
                                    maximumNumberAttributeTypes={3}
                                    extendedStyles={styles.attributes}
                                    fallbackOnNormalAttributeType={false}
                                    data-test-selector={`productCarouselProduct_attributes_${product.id}`} /* Store Custom Code */
                                />
                            ) : null}
                        </StyledWrapper>
                    ) : null}
                    {/* Bunzl Moved Code */}
                    {/* Starter Custom Code */}
                    {showTextBadges && textBadges && (
                        <ProductTextBadges
                            extendedStyles={styles.productTextBadgesStyle}
                            badgeList={textBadges}
                            maxBadges={maximumNumberOfTextBadges ?? 4}
                            data-test-selector={`productCarouselProduct_textBadges_${product.id}`} /* Store Custom Code */
                        />
                    )}
                    {showImageBadges && imageBadges && (
                        <ProductImageBadges
                            // Store Custom Code - added badgeSizes
                            badgeSizes={styles.badgeSizes}
                            badgeList={imageBadges}
                            maxBadges={maximumNumberOfImageBadges ?? 4}
                            extendedStyles={styles.nonOverlayImageBadgesStyle}
                            data-test-selector={`productCarouselProduct_imageBadges_${product.id}`} /* Store Custom Code */
                        />
                    )}
                    {/* Foundation - End */}
                </StyledWrapper>
                {/* Foundation - Start */}
                {isHideSignInToSeePriceButton && !isSignedInAndhasToBeSignedIn ? null : (
                    <StyledWrapper
                        {...styles.actionWrapper}
                        data-test-selector={`productCarouselProduct_actionWrapper_${product.id}`} /* Store Custom Code */
                    >
                        {isSignedInAndhasToBeSignedIn && (
                            <StyledWrapper
                                {...styles.priceSection}
                                data-test-selector={`productCarouselProduct_priceSection_${product.id}`} /* Store Custom Code */
                            >
                                {showPrice && (
                                    <>
                                        <ProductPrice
                                            showLabel={false}
                                            product={productContext}
                                            extendedStyles={styles.price}
                                            data-test-selector={`productCarouselProduct_price_${product.id}`} /* Store Custom Code */
                                        />
                                        {product.unitOfMeasures && (
                                            <ProductUnitOfMeasureSelect
                                                labelOverride=""
                                                extendedStyles={styles.productUnitOfMeasureSelectStyles}
                                                id={`${carouselId}-uom`}
                                                data-test-selector={`productCarouselProduct_uomSelect_${product.id}`} /* Store Custom Code */
                                            />
                                        )}
                                        {/* Store Custom Code */}
                                        {showInventoryAvailability && showAvailability ? (
                                            <ProductContextAvailability
                                                extendedStyles={styles.availability}
                                                data-test-selector={`productCarouselProduct_availability_${product.id}`} /* Store Custom Code */
                                            />
                                        ) : null}
                                    </>
                                )}
                            </StyledWrapper>
                        )}
                        {/* Store Custom Code */}
                        <ProductQuantityBreakPricing
                            extendedStyles={styles.productQuantityBreakPricingStyles}
                            data-test-selector={`productCarouselProduct_qtyBreakPricing_${product.id}`} /* Store Custom Code */
                        />
                    </StyledWrapper>
                )}
                {/* Store Custom Code - Start */}
                <StyledWrapper
                    {...styles.buttonRow}
                    data-test-selector={`productCarouselProduct_buttonRow_${product.id}`} /* Store Custom Code */
                >
                    {!isVariantParent && (
                        <ProductQuantityOrdered
                            extendedStyles={styles.quantityOrdered}
                            data-test-selector={`productCarouselProduct_qtyOrdered_${product.id}`} /* Store Custom Code */
                        />
                    )}
                    <ProductAddToCartButton
                        {...styles.productAddToCartButton}
                        onAddToCartClick={() => trackProductRecommendation(false)}
                        data-test-selector={`productCarouselProduct_addToCartButton_${product.id}`} /* Store Custom Code */
                    />
                </StyledWrapper>
                <StyledWrapper
                    {...styles.compareAddToListWrapper}
                    data-test-selector={`productCarouselProduct_compareAddToListWrapper_${product.id}`} /* Store Custom Code */
                >
                    <CompareCheckbox
                        extendedStyles={styles.compareCheckbox}
                        productContext={productContext}
                        data-test-selector={`productCarouselProduct_compareCheckbox_${product.id}`} /* Store Custom Code */
                    />
                    {showAddToList && (
                        <StyledWrapper
                            {...styles.addToListWrapper}
                            data-test-selector={`productCarouselProduct_addToListWrapper_${product.id}`} /* Store Custom Code */
                        >
                            {isAuthenticated && (
                                <ProductAddToListLink
                                    data-test-selector={`productCarouselProduct_addToListLink_${productContext.product.id}`} /* Store Custom Code */
                                    extendedStyles={styles.addToListLink}
                                    showAsLink={true}
                                    hideIcon={false}
                                />
                            )}
                        </StyledWrapper>
                    )}
                </StyledWrapper>
                {/* Store Custom Code - End */}
            </ProductContext.Provider>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductCarouselProduct);
